import { render } from "./CustomerSegmentCreate.vue?vue&type=template&id=e6b57dc2&scoped=true"
import script from "./CustomerSegmentCreate.vue?vue&type=script&lang=js"
export * from "./CustomerSegmentCreate.vue?vue&type=script&lang=js"

import "./CustomerSegmentCreate.vue?vue&type=style&index=0&id=e6b57dc2&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6b57dc2"]])

export default __exports__